export const searchQueryParam = "szukaj";